module.exports = __webpack_public_path__ + "static/media/default-event-featured.cace0044.png";